export default function loadImageAsync(item) {
    return new Promise((resolve, reject) => {
        item.img = document.createElement('img');
        item.img.onload = () => resolve();
        item.img.onerror = () => reject();
        item.img.src = item.url;
    });
}
